import face1Orange from "/media/flex/face1orange.json"
import face2Pink from "/media/flex/face2pink.json"
import face3Blue from "/media/flex/face3blue.json"

import faceBorat from "/media/flex/faceBorat.json"

export const MAX_ANIMATEABLE_FLEXES = 8
export const FLEX_DISPATCH_INTERVAL = 33 // ms
export const BOARD_SWAP_INTERVAL = 5000 // ms
export const QUIZ_PANEL_INTRO_ANIMATION_DURATION = 2750 // ms

export const latencyComp = 4 // in seconds

export const FLEX_VARIANTS = {
  blue: {
    face: face3Blue,
    colors: {
      main: "#71bcd6",
      dark: "#2b7cd0"
    }
  },
  orange: {
    face: face1Orange,
    colors: {
      main: "#f6a121",
      dark: "#f46822"
    }
  },
  pink: {
    face: face2Pink,
    colors: {
      main: "#f75ea8",
      dark: "#ea116f"
    }
  },
}

